import { ITrackProductTileProviderProps } from "@faire/deprecated-retailer-visitor-shared/hooks/ProductTileImpression/ProductTileViewImpressionProvider";
import { IBadgeList } from "@faire/web-api--source/indigofair/badges/IBadgeList";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";

export interface IProductLinkProps {
  productUrl: string;
  replace?: boolean;
}

export interface IProductTileImageConfigProps {
  showVerticalImagery?: boolean;
  altTag?: string;
}

export interface IBrandLinkProps {
  brandUrl: string;
  brandToken: string;
  replace?: boolean;
}

export interface IServerRenderedTile {
  trackingProps: ITrackingProps;
  bottomSlot?: React.ReactNode;
  middleSlot?: React.ReactNode;
  overlaySlot?: React.ReactNode;
  topSlot?: React.ReactNode;
}

export interface ITrackingProps {
  productToken?: string;
  brandToken?: string;
  selectedProductOptionToken?: string;
  isPromoted?: boolean;
  impressionId?: string;
  promotedBy?: Array<keyof typeof IProduct.PromotedType>;
  badgeList?: IBadgeList;
  bestImage?: IImage;
  images?: Array<IImage>;
  optionImages?: Array<IImage>;
  settingsToAssignOnView?: Array<string>;
  dataTestId?: string;
  showVerticalImagery?: boolean;
  initialOptionToken?: string;
}
export interface ILoggingContext {
  impressionProviderProps: ITrackProductTileProviderProps & {
    trackedLinkContainerName: string | undefined;
    isNewProductsCategory?: boolean;
  };
}

export enum ProductTileType {
  TILE_WITH_BRAND = "TILE_WITH_BRAND",
  TILE_WITHOUT_BRAND = "TILE_WITHOUT_BRAND",
  QUICK_ADD_ONLY_TILE = "QUICK_ADD_ONLY_TILE",
}

export interface ITileInteractions {
  tileActions?: {
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    onMouseDown?: () => void;
    onTouchStart?: () => void;
    onProductClick?: (productToken: string) => void;
    onBrandClick?: () => void;
    onBrandLinkFocus?: () => void;
    onBrandLinkBlur?: () => void;
  };
  overlayActions?: {
    onFavouriteClick?: () => void;
    onSaveToBoardSubmit?: () => void;
    onRemoveFromBoardSubmit?: () => void;
    onQuickAddClick?: (newQuantity?: number) => void;
    onQuickAddSubmit?: (newQuantity?: number) => void;
    onChooseOptionClick?: (newQuantity?: number) => void;
    onChooseOptionQuantityUpdateSubmit?: (newQuantity?: number) => void;
  };
  props?: {
    productLinkProps?: IProductLinkProps;
    brandLinkProps?: IBrandLinkProps;
    productToken?: string;
    initialOptionToken?: string;
  };
}

export interface ProductTileSwatchesProps {
  optionDetails?: ILeanProductTile.IOptionsDetails;
}
